import React, { useState } from 'react';
import { Row } from 'reactstrap';
import FilterInput from '../FilterInput';
import useDisplayMessage from '../Common/useDisplayMessage';
import KaAlert from '../Common/KaAlert';
import PermissionButton from '../UserAccess/PermissionButton';
import PurchaseOrderTable, { PoModalState } from './PurchaseOrderTable';
import Toggle from '../Common/Toggle';
import { SiteFilterPill, useSiteFilter } from '../UserAccess/SiteScope/SiteFilterPill';
import '../Common/Filters/FilterPill.css';
import { PurchaseOrderDto } from '../Requests/PurchaseOrders/useGetPurchaseOrders';
import { PurchaseOrderTransactionPage } from './Transactions/PurchaseOrderTransactionPage';

const PurchaseOrderPage = () => {
  const [filterText, setFilterText] = useState('');
  const [viewCompleted, setViewCompleted] = useState(false);
  const [modalState, setModalState] = useState<PoModalState>({ state: 'Hidden' });
  const [poTransactionsToView, setPoTransactionToView] = useState<PurchaseOrderDto | undefined>(undefined);
  const displayMessage = useDisplayMessage();
  const siteFilter = useSiteFilter();

  const handleViewCompleted = (completed: boolean) => {
    setFilterText('');
    displayMessage.clear();
    setModalState({ state: 'Hidden' });
    setViewCompleted(completed);
  }

  return <div>
    {
      poTransactionsToView
        ? <PurchaseOrderTransactionPage
          purchaseOrder={poTransactionsToView}
          backClicked={() => setPoTransactionToView(undefined)} />
        : <>
          <Row className="justify-content-between mb-2">
            <h2 className="col-auto ka-blue">Purchase Orders</h2>
            <PermissionButton
              permission="purchaseOrderModify"
              className='col-auto btn-ghost-primary'
              onClick={() => setModalState({ state: 'Create' })}>
              Create Purchase Order
            </PermissionButton>
          </Row>
          <form>
            <KaAlert displayMessage={displayMessage.message} onClose={displayMessage.clear} />
            <div className="row gx-2 gx-md-3 mb-3">
              <div className="col-md-4 mb-2 mb-md-0">
                <FilterInput
                  placeholder="Search by number, supplier, or product"
                  value={filterText}
                  onFilterTextChange={(text) => setFilterText(text)} />
              </div>
            </div>
          </form>
          <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
            <Toggle
              value={viewCompleted}
              offLabel="Active"
              onLabel="Completed"
              onChange={handleViewCompleted} />
            <div className="vr filter-pill-divider mx-1" />
            <SiteFilterPill filter={siteFilter} />
          </div>
          <PurchaseOrderTable
            filterText={filterText}
            siteFilter={siteFilter}
            modalState={modalState}
            setModalState={setModalState}
            requestSuccessful={displayMessage.success}
            requestFailed={displayMessage.fail}
            setViewTransaction={setPoTransactionToView}
            completed={viewCompleted} />
        </>
    }
  </div>;
}

export default PurchaseOrderPage;
